import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, InfoBox } from '@tryhackme/thm-ui-components';
import styled from 'styled-components';
import type { RolePillProps } from './certification-details.types';

export const StyledSubscriptionDetails = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.background.main};
  box-shadow: ${({ theme }) => theme.boxShadow.light};
  padding: 4.6rem;
  border-radius: ${({ theme }) => theme.radius.small};
`;

export const StyledTitle = styled.p`
  font-size: 2.4rem;
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.text.main};
  margin-bottom: 1.6rem;
`;

export const StyledDescription = styled.p`
  color: ${({ theme }) => theme.colors.text.secondary};
  font-size: 0.875rem;
  margin-bottom: 1.6rem;
`;

export const StyledRow = styled.div`
  display: grid;
  grid-template-columns: repeat(1, 1fr);
  gap: 0;
  padding-bottom: 1.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: repeat(2, 1fr);
    gap: 3.2rem;
  }
`;

export const StyledButtonsRow = styled.div`
  display: grid;
  gap: 1.6rem;
  grid-template-columns: repeat(4, 1fr);
  margin-top: 1.6rem;
`;

export const StyledToggleWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: 1.6rem;
  gap: 1.6rem;
  margin-top: 1.6rem;
  margin-bottom: 0.8rem;
  color: ${({ theme }) => theme.colors.text.main};
`;

export const StyledRolePills = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-top: 0.5rem;
`;

export const StyledRolePill = styled.div<RolePillProps>`
  font-size: ${({ theme }) => theme.fonts.sizes.tiny};
  font-weight: ${({ theme }) => theme.fonts.weight.bolder};
  text-transform: uppercase;
  padding: 0.4rem 0.8rem;
  border-radius: 4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ theme, color }) => {
    const palette = {
      green: theme.colors.success.light,
      blue: theme.colors.info.light,
      orange: theme.colors.warning.light,
    };
    return palette[color];
  }};
`;

export const StyledInfoIcon = styled(FontAwesomeIcon)`
  color: ${({ theme }) => theme.colors.info.main};
  font-size: 2rem;
`;

export const StyledInfoBoxWithBorder = styled(InfoBox)`
  border: 0.1rem solid ${({ theme }) => theme.colors.info.main};
  margin-top: 1rem;
  display: flex;
  align-items: center;
  gap: 0.8rem;
  font-size: ${({ theme }) => theme.fonts.sizes.default};
`;

export const StyledResetButton = styled(Button)`
  gap: 1rem;
`;
